import {
  SET_DASHBOARD,
  SET_PAGE,
  SET_ARTICLES,
  SET_ARTICLE,
  SET_AUTHORS,
  SET_CATEGORIES,
  SET_SURVEYS,
  SET_SURVEY,
  SET_METRICS,
  SET_METRIC,
  SET_EXCEPTIONS,
  SET_EXCEPTION,
  AdminActionTypes,
  ModuleType,
} from './Types';
import {ThunkResult} from '../index';
import {Dashboard} from '../../Services/DashboardService';
import {Page} from '../../Models';
import {Article} from '../../Services/ArticleService';
import {Author} from '../../Services/AuthorService';
import {Survey} from '../../Services/SurveyService';
import {Metric} from '../../Services/MetricService';
import {Exception} from '../../Services/ExceptionService';

export const setDashboard = (dashboard: Dashboard): AdminActionTypes => {
  return {
    type: SET_DASHBOARD,
    payload: dashboard,
  };
};

export const setPage = (module: ModuleType, page: number): AdminActionTypes => {
  return {
    type: SET_PAGE,
    payload: {
      module,
      page,
    },
  };
};

export const setArticles = (articles: Page<Article>): AdminActionTypes => {
  return {
    type: SET_ARTICLES,
    payload: articles,
  };
};

export const setArticle = (article: Article): AdminActionTypes => {
  return {
    type: SET_ARTICLE,
    payload: article,
  };
};

export const setAuthors = (authors: Author[]): AdminActionTypes => {
  return {
    type: SET_AUTHORS,
    payload: authors,
  };
};

export const setCategories = (categories: string[]): AdminActionTypes => {
  return {
    type: SET_CATEGORIES,
    payload: categories,
  };
};

export const setSurveys = (surveys: Page<Survey>): AdminActionTypes => {
  return {
    type: SET_SURVEYS,
    payload: surveys,
  };
};

export const setSurvey = (survey: Survey): AdminActionTypes => {
  return {
    type: SET_SURVEY,
    payload: survey,
  };
};

export const setMetrics = (metrics: Page<Metric>): AdminActionTypes => {
  return {
    type: SET_METRICS,
    payload: metrics,
  };
};

export const setMetric = (metric: Metric): AdminActionTypes => {
  return {
    type: SET_METRIC,
    payload: metric,
  };
};

export const setExceptions = (exceptions: Page<Exception>): AdminActionTypes => {
  return {
    type: SET_EXCEPTIONS,
    payload: exceptions,
  };
};

export const setException = (exception: Exception): AdminActionTypes => {
  return {
    type: SET_EXCEPTION,
    payload: exception,
  };
};

export const loadDashboardCreator = (): ThunkResult<Promise<Dashboard>> => {
  return async (dispatch, getState) => {
    const {auth: {dashboardService}} = getState();

    try {
      const res = await dashboardService.dashboard();
      if (res.parsedBody !== undefined) {
        dispatch(setDashboard(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }

    dispatch(loadAuthorsCreator());

    return getState().admin.dashboard;
  };
};

export const loadArticlesCreator = (page: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {auth: {articleService}} = getState();

    try {
      const res = await articleService.listAll(page);
      if (res.parsedBody !== undefined) {
        dispatch(setArticles(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const loadAuthorsCreator = (): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {auth: {authorService}} = getState();

    try {
      const res = await authorService.list();
      if (res.parsedBody !== undefined) {
        dispatch(setAuthors(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const loadSurveysCreator = (page: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {auth: {surveyService}} = getState();

    try {
      const res = await surveyService.list(page);
      if (res.parsedBody !== undefined) {
        dispatch(setSurveys(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const loadMetricsCreator = (page: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {auth: {metricService}} = getState();

    try {
      const res = await metricService.list(page);
      if (res.parsedBody !== undefined) {
        dispatch(setMetrics(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const loadExceptionsCreator = (page: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {auth: {exceptionService}} = getState();

    try {
      const res = await exceptionService.list(page);
      if (res.parsedBody !== undefined) {
        dispatch(setExceptions(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

